var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowSwitch = function SvgArrowSwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m.17 3.1.025-.023L3.773.152A.56.56 0 0 1 4.2.026a.56.56 0 0 1 .389.22q.15.194.125.438a.58.58 0 0 1-.217.4L2.245 2.925h3.204q1.886 0 3.218 1.362Q10 5.653 10 7.579q0 1.927-1.333 3.288c-.888.908-3.392 1.154-4.649 1.154a.56.56 0 0 1-.412-.174.58.58 0 0 1-.17-.421q0-.246.17-.421a.56.56 0 0 1 .412-.175c.936 0 3.164-.13 3.825-.805q.992-1.012.992-2.446t-.992-2.45q-.99-1.014-2.394-1.013H2.234l2.387 1.97a.58.58 0 0 1 .213.401.58.58 0 0 1-.127.436.56.56 0 0 1-.39.22.56.56 0 0 1-.428-.128L.216 3.985a.6.6 0 0 1-.174-.24l-.007-.017-.003-.01-.01-.028A.6.6 0 0 1 0 3.523l.002-.05q0-.01.002-.019l.017-.093a.5.5 0 0 1 .04-.108l.032-.057A.6.6 0 0 1 .171 3.1",
    clipRule: "evenodd"
  })));
};
export default SvgArrowSwitch;